module.exports = __webpack_public_path__ + "static/10-ed4e1a765999d912e4134857d2cfd7ed.jpg";